/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface CoinPayments
 */
export class CoinPayments {
    /**
     *
     * @type {string}
     * @memberof CoinPayments
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof CoinPayments
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof CoinPayments
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof CoinPayments
     */
    clientId: string;
    /**
     *
     * @type {string}
     * @memberof CoinPayments
     */
    clientSecret: string;
    /**
     *
     * @type {string}
     * @memberof CoinPayments
     */
    merchantEmail: string;
    /**
     *
     * @type {boolean}
     * @memberof CoinPayments
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CoinPayments
     */
    autoApprove: boolean;
}
